import { useEffect, useState } from 'react';
import { delayTo, nextBoundary, type ClockLesson } from '../utils/lessonClock';

/**
 * The clock the lesson rows and page read (Ryan, 30 Oct): now, re-read when the soonest call opens or window
 * ends (one timeout, utils/lessonClock), and when the lessons' times change (a live update, a move). No polling.
 */
export function useLessonClock(lessons: ClockLesson[]): number {
  const [now, setNow] = useState(() => Date.now());
  const key = lessons.map((b) => `${b.scheduledStartAt}|${b.windowOpenAt ?? ''}|${b.windowCloseAt ?? ''}|${b.durationMinutes ?? ''}`).join(',');
  // The bookings changed: read the clock again.
  useEffect(() => { setNow(Date.now()); }, [key]); // eslint-disable-line react-hooks/set-state-in-effect
  useEffect(() => {
    const next = nextBoundary(lessons, now);
    if (next === null) return;
    const id = setTimeout(() => setNow(Date.now()), delayTo(next, now));
    return () => clearTimeout(id);
  }, [key, now]); // eslint-disable-line react-hooks/exhaustive-deps
  return now;
}
